import script from "./History.vue?vue&type=script&setup=true&lang=js"
export * from "./History.vue?vue&type=script&setup=true&lang=js"

import "./History.vue?vue&type=style&index=0&id=eb4023ce&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-eb4023ce"]])

export default __exports__